import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No. El programa está pensado para empezar desde cero, incluso si hace mucho que no entrenás.'
  }, {
    q: '¿Cuánto tiempo tengo que dedicar por día?',
    a: 'Entre 10 y 25 minutos. Está diseñado para adaptarse a rutinas de mamá con poco tiempo.'
  }, {
    q: '¿Lo puedo hacer desde casa?',
    a: 'Sí. Todo el sistema está pensado para hacerlo en casa, sin necesidad de gimnasio.'
  }, {
    q: '¿Funciona si estoy muy cansada?',
    a: 'Sí. Justamente está diseñado para mujeres que están cansadas y no pueden hacer entrenamientos largos.'
  }, {
    q: '¿Tengo que hacer dieta estricta?',
    a: 'No. Vas a aprender a comer mejor sin restricciones extremas ni prohibiciones imposibles.'
  }, {
    q: '¿En cuánto tiempo voy a ver resultados?',
    a: 'Muchas mujeres empiezan a notar cambios en las primeras semanas, pero los resultados dependen de tu constancia.'
  }, {
    q: '¿Sirve si tuve hijos hace mucho tiempo?',
    a: 'Sí. No importa si fuiste mamá hace meses o años, el sistema funciona igual.'
  }, {
    q: '¿Qué pasa si un día no puedo entrenar?',
    a: 'No pasa nada. El sistema es flexible y está pensado para días caóticos.'
  }, {
    q: '¿Cómo accedo al programa?',
    a: 'Una vez que comprás, recibís acceso inmediato al contenido completo.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 7 días para probarlo. Si no te gusta, podés pedir el reembolso.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-6 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-84">
      <div className="text-center mb-4" data-id="element-85">
        <h2 className="font-display text-xl md:text-3xl font-bold flex items-center justify-center gap-2 text-gray-900" data-id="element-86">
          <span data-id="element-87">❓</span> PREGUNTAS FRECUENTES
        </h2>
      </div>

      <div className="space-y-2" data-id="element-88">
        {faqs.map((faq, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className="bg-brand-card border border-pink-200 rounded-xl overflow-hidden shadow-sm" data-id="element-89">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3 flex items-center justify-between text-left focus:outline-none" data-id="element-90">
              <span className="font-bold text-sm md:text-base text-gray-900" data-id="element-91">
                {faq.q}
              </span>
              <ChevronDown size={18} className={`text-brand-accent transition-transform duration-300 flex-shrink-0 ml-2 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-92" />
            </button>
            <AnimatePresence data-id="element-93">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-94">
                  <div className="px-4 pb-3 text-gray-500 text-sm md:text-base" data-id="element-95">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}